// Locale pt-BR para o vue-datepicker-next passado via prop :lang.
// NÃO importar 'vue-datepicker-next/locale/pt-br': o arquivo é UMD e chama
// DatePicker.locale(), que não existe no bundle ESM do Vite (TypeError em prod).
export const DATE_PICKER_LANG_PT_BR = {
  formatLocale: {
    months: [
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ],
    monthsShort: [
      'jan',
      'fev',
      'mar',
      'abr',
      'mai',
      'jun',
      'jul',
      'ago',
      'set',
      'out',
      'nov',
      'dez',
    ],
    weekdays: [
      'domingo',
      'segunda-feira',
      'terça-feira',
      'quarta-feira',
      'quinta-feira',
      'sexta-feira',
      'sábado',
    ],
    weekdaysShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 1,
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMMM',
  monthBeforeYear: true,
};
